import { Typography } from "@mui/material";

type NumberBoxProps = {
  number: any;
  icon: any;
  variant?: any;
  title: any;
  subtitle?: any;
};

export default function NumberBox(props: NumberBoxProps) {
  return (
    <div>
      <Typography variant="h6" fontWeight={600}>
        {props.title}
      </Typography>
      <Typography variant={props.variant ? props.variant : "h4"} marginTop={1}>
        {props.icon}&nbsp;{props.number != -1 ? props.number : ""}
      </Typography>
      {props.subtitle ? (
        <Typography
          variant="body2"
          fontWeight={400}
          fontStyle={"italic"}
          marginTop={1}
        >
          * {props.subtitle}
        </Typography>
      ) : (
        ""
      )}
    </div>
  );
}
